import {
    GET_TEAM_RANKING_ERROR,
    GET_TEAM_RANKING_LOADING,
    GET_TEAM_RANKING_SUCCESS,
} from "../../../constant/actionTypes";
import {apiGet} from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";

export const getAllTeamRanking = (leagueId) => (dispatch) => {
    dispatch({type: GET_TEAM_RANKING_LOADING});

    apiGet(
        `${ApiEndpoints.teamRanking.league}/${leagueId}${ApiEndpoints.teamRanking.leaderboard}`,
        (response) => {
            if (response.success === true) {
                dispatch({type: GET_TEAM_RANKING_SUCCESS, response: response});
            } else {
                dispatch({type: GET_TEAM_RANKING_ERROR, response: response.message});
            }
        },
        (error) => {
            dispatch({type: GET_TEAM_RANKING_ERROR, response: error});
        }
    );
};